import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Verification({verificationBar, toggleVerificationBar }) {
    const { user } = useUser();
    const [type, setType] = useState();
    const [files, setFiles] = useState([])
    const [fileName, setFileName] = useState()
    const [files1, setFiles1] = useState([])
    const [fileName1, setFileName1] = useState()
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
          minWidth: "135px"
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    const typeoptions = [
        { value: "Driver License", label: "Driver License" },
        { value: "Identity Card", label: "Identity Card" },
        { value: "Social Security Card", label: "Social Security Card" },
        { value: "Passport", label: "Passport" },
    ];
    useEffect(() => {
      if(type && fileName && fileName1){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [type, fileName, fileName1]);
    const ValidateVerification = () =>{
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/verify.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ upload_id: true, type: type, id_photo: fileName, id_photo1: fileName1 })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setLoading(false);
          toggleVerificationBar();
          toast.success(data.result);
        }else{
          toast.error(data.message);
        }
      })
      .catch(err => {
        console.error(err)
        setLoading(false);
        toast.error('There was an issue processing your deposit.')
      })
    }
    return (
    <div className={`notifybar ${verificationBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleVerificationBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Verification Settings </p>
            </div> 
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleVerificationBar()}}/>
        </div>
        <div className="sidebar-navbar" style={{height: 'auto'}}>
            {user.verify !== 1 && (
            <>
              <p className="mb-4 fw-bold text-danger" style={{fontSize: '14px'}}>To verify your account, please provide your information with a valid means of identification attached as an image document.</p>
              <label className="fw-semibold my-2" style={{fontSize: '14px'}}>Document type:</label>
              <Select
                  options={typeoptions} 
                  value={typeoptions.find((opt) => opt.value === type)}
                  onChange={(e) => setType(e.value)}
                  styles={darkThemeStyles}
                  className="w-full"
              />
              <label className="fw-semibold my-2" style={{fontSize: '14px'}}>ID Front:</label>
              <FilePond
                files={files}
                onupdatefiles={setFiles}
                allowMultiple={false}
                maxFiles={3}
                name="file"
                labelIdle="Click here to upload your front id"
                server={{
                  process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append("file", file);
                    const request = new XMLHttpRequest();
                    request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = () => {
                      const res = JSON.parse(request.responseText);
                      if (res.success) {
                        setFileName(res.filename);
                        load(res.filename);
                      } else {
                        error(res.error || "Upload failed");
                      }
                    };
                    request.onerror = () => {
                      error("Upload error");
                    };
                    request.send(formData);
                    return {
                      abort: () => {
                        request.abort();
                        abort();
                      }
                    };
                  },
                  revert: (serverId, load, error) => {
                    fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({ filename: fileName })
                    })
                      .then((res) => res.json())
                      .then((data) => {
                        if (data.success) {
                          setFileName("");
                          setFiles([]);
                          load();
                        } else {
                          error(data.error || "Failed to delete file");
                        }
                      })
                      .catch(() => {
                        error("Delete request failed");
                      });
                  }
                }}
              />
              <label className="fw-semibold my-2" style={{fontSize: '14px'}}>ID Back:</label>
              <FilePond
                files={files1}
                onupdatefiles={setFiles1}
                allowMultiple={false}
                maxFiles={3}
                name="file"
                labelIdle="Click here to upload your back id"
                server={{
                  process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append("file", file);
                    const request = new XMLHttpRequest();
                    request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = () => {
                      const res = JSON.parse(request.responseText);
                      if (res.success) {
                        setFileName1(res.filename);
                        load(res.filename);
                      } else {
                        error(res.error || "Upload failed");
                      }
                    };
                    request.onerror = () => {
                      error("Upload error");
                    };
                    request.send(formData);
                    return {
                      abort: () => {
                        request.abort();
                        abort();
                      }
                    };
                  },
                  revert: (serverId, load, error) => {
                    fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({ filename: fileName1 })
                    })
                      .then((res) => res.json())
                      .then((data) => {
                        if (data.success) {
                          setFileName1("");
                          setFiles1([]);
                          load();
                        } else {
                          error(data.error || "Failed to delete file");
                        }
                      })
                      .catch(() => {
                        error("Delete request failed");
                      });
                  }
                }}
              />
              <div className={`myBtn w-100 text-center mt-5 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateVerification : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Request verification'}</div>
            </>
            )}
            {user.verify === 1 && (
              <>
                <div className="d-flex justify-content-center">
                  <img src={require('../images/pngwing.png')} alt="success" width="20" className="mt-5 mb-3" style={{width: '200px'}} />
                </div>
                <h5 className="mb-1 text-white fw-bold text-center">Successful Verification</h5>
                <p className="fw-bold text-secondary" style={{fontSize: '14px'}}>We have successfully verified your account and you are now able to use all features of our website. Thank you for completing the verification process and ensuring the security of your account and our platform. If you have any questions or concerns, please do not hesitate to contact us. Our support team is always available to assist you.</p>
              </>
            )}
        </div>
    </div>
    )
}

export default Verification